module.exports = __webpack_public_path__ + "img/close.fe3b52a4.svg";